module.exports = __webpack_public_path__ + "media/images/sound-a761cab194cae8089b437b6e9455f59c.png";